import React from "react";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import { array, arrayOf, shape, string, number, object } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import CardBlock, {
	CardBlockRow,
	CardBlockCol,
} from "@insightfulscience/atomic-react/r2/CardBlock";
import getContentProps from "../../../../../utils/getContentProps";

const RecommendedVideos = ({ videos }) => {
	return (
		<LandingSimpleSection bgColor="white" isBorderNone>
			<LandingSimpleSection.Title>Recommended Resources</LandingSimpleSection.Title>
			<CardBlockRow>
				{videos.map(video => {
					const contentProps = getContentProps(video.sys.contentType.sys.id);

					return (
						<CardBlockCol key={video.sys_id}>
							<CardBlock
								LinkComponent={Link}
								cardType={contentProps.typePlaceholder}
								titleText={video.fields.title}
								imgSrc={video.fields.thumbnail.fields.file.url}
								descriptionText={video.fields.metaDescription}
								href={`${contentProps.alias}/${video.fields.slug}`}
								linkButtonText={contentProps.linkPlaceholder}
							/>
						</CardBlockCol>
					);
				})}
			</CardBlockRow>
		</LandingSimpleSection>
	);
};

RecommendedVideos.propTypes = {
	videos: arrayOf(
		shape({
			fields: shape({
				body: object, // eslint-disable-line react/forbid-prop-types,
				lead: string,
				metaDescription: string,
				slug: string,
				thumbnail: shape({
					fields: shape({
						description: string,
						file: shape({
							contentType: string,
							details: shape({
								image: shape({
									height: number,
									width: number,
								}),
								size: number,
							}),
							fileName: string,
							url: string,
						}),
						title: string,
					}),
					metadata: shape({
						tags: array, // eslint-disable-line react/forbid-prop-types,
					}),
					sys: object, // eslint-disable-line react/forbid-prop-types,
				}),
				title: string,
				toClick: string,
			}),
			metadata: shape({
				tags: array, // eslint-disable-line react/forbid-prop-types,
			}),
			sys: object, // eslint-disable-line react/forbid-prop-types,
		}),
	),
};

export default RecommendedVideos;
